export default "__VITE_ASSET__f24GUH25__"